export const selectedLanguageSelector = state => state?.app?.selectedLang;
export const appConfigErrorSelector = state => state?.app?.isError;
export const appConfigLoadingSelector = state => state?.app?.isLoading;
export const messagesArraySelector = state => state?.app?.messagesArr;

export const sidebarShowSelector = state => state?.app?.sidebarShow;
export const navigationItemsSidebarSelector = state => state?.app?.navigationItemsSidebar;
